


<template>
  <div class="azulMuyClaro">
    <landing />
    <nosotros />
    <marcas />
    <sectores />
    <servicios />
    <contacto />
    <!-- <digitalizacion /> -->
    <!-- <valoraciones /> -->
    <!-- <cliente /> -->
  </div>
</template>

<script>
import Landing from "@/components/section/index/Landing.vue";
import Nosotros from "@/views/Nosotros.vue";
import Marcas from "@/components/section/index/Marcas.vue";
// import Valoraciones from "@/components/section/index/Valoraciones.vue";
// import Digitalizacion from "@/components/section/index/Digitalizacion.vue";
import Sectores from "@/views/Sectores.vue";
/* import Cliente from "@/components/section/index/Cliente.vue"; */
import Servicios from "@/views/Servicios.vue";
import Contacto from "@/views/Contacto.vue";

export default {
  name: "index",

  components: {
    Landing,
    Nosotros,
    Marcas,
    // Valoraciones,
    // Digitalizacion,
    // Cliente,
    Sectores,
    Servicios,
    Contacto
  },
};
</script>

<style scoped></style>
